import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';

@Component({
  selector: 'app-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.scss']
})
export class MetricsComponent implements OnInit {



  // view: any[] = [700, 500];
  view: any[] = [720, 520];
  ngxChartWidth = 2.5;
  // BillingTypeNames = ['Fixed Non-Billable', 'Fixed Billable', 'Time and Material Non-Billable', 'Time and Material Billable'];
  BillingTypeNames = [
    {
      'resourcesType': 'Fixed Non-Billable',
      'arrayNameToPush': 'fixedNonBillable'
    },
    {
      'resourcesType': 'Fixed Billable',
      'arrayNameToPush': 'fixedBillable'
    },
    {
      'resourcesType': 'Time and Material Non-Billable',
      'arrayNameToPush': 'dedicatedNonBillable'
    },
    {
      'resourcesType': 'Time and Material Billable',
      'arrayNameToPush': 'dedicatedBillable'
    }
  ];
  public yAxisTickFormattingFn = this.yAxisTickFormatting.bind(this);

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Reporting To';
  showYAxisLabel = true;
  yAxisLabel = 'Resource Type';



  reportingToShowXAxis = true;
  reportingToShowYAxis = true;
  reportingToGradient = false;
  reportingToShowLegend = true;
  reportingToShowXAxisLabel = true;
  reportingToxAxisLabel = 'Resource Billing Type ';
  reportingToShowYAxisLabel = true;
  reportingToyAxisLabel = 'Count of Resource';


  fixedNonBillableShowXAxis = true;
  fixedNonBillableShowYAxis = true;
  fixedNonBillableGradient = false;
  fixedNonBillableShowLegend = true;
  fixedNonBillableShowXAxisLabel = true;
  fixedNonBillablexAxisLabel = 'Reporting To';
  fixedNonBillableShowYAxisLabel = true;
  fixedNonBillableyAxisLabel = 'Fixed Non - Billable';

  fixedBillableShowXAxis = true;
  fixedBillableShowYAxis = true;
  fixedBillableGradient = false;
  fixedBillableShowLegend = true;
  fixedBillableShowXAxisLabel = true;
  fixedBillablexAxisLabel = 'Reporting To';
  fixedBillableShowYAxisLabel = true;
  fixedBillableyAxisLabel = 'Fixed - Billable';


  dedicatedNonBillableShowXAxis = true;
  dedicatedNonBillableShowYAxis = true;
  dedicatedNonBillableGradient = false;
  dedicatedNonBillableShowLegend = true;
  dedicatedNonBillableShowXAxisLabel = true;
  dedicatedNonBillablexAxisLabel = 'Reporting To';
  dedicatedNonBillableShowYAxisLabel = true;
  dedicatedNonBillableyAxisLabel = 'Dedicated Nom - Billable';


  dedicatedBillableShowXAxis = true;
  dedicatedBillableShowYAxis = true;
  dedicatedBillableGradient = false;
  dedicatedBillableShowLegend = true;
  dedicatedBillableShowXAxisLabel = true;
  dedicatedBillablexAxisLabel = 'Reporting To';
  dedicatedBillableShowYAxisLabel = true;
  dedicatedBillableyAxisLabel = 'Dedicated - Billable';




  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };



  single = [];
  reportingToWithCount = [];
  tenantId: any;
  reportingToWithBillingType = [];
  fixedBillable = [];
  fixedNonBillable = [];
  dedicatedBillable = [];
  dedicatedNonBillable = [];

  constructor(
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    private router: Router
  ) {
      this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
      this.getProMembers();
      this.getEmployeeListForReportingTo();
      this.getEmployeeListForReportingToWithBillingType();
  }
  ngOnInit(): void {

  }
  yAxisTickFormatting(value) {
    return value;
  }
  onSelect(event) {
    console.log(event);
    this.router.navigate(['metrics-details']);
  }
  async getProMembers(): Promise<any> {
    const ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
    const projectMembers = new this.parseService.instance.Query(ProjectMembers);
    projectMembers.include('user');
    projectMembers.include('user.profile');
    projectMembers.equalTo('status', 'Assigned');
    projectMembers.equalTo('tenantId', this.tenantId);
    projectMembers.equalTo('isActive', true);
    // projectMembers.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.selectedProjectId });
    projectMembers.limit(500000);
    const results =  await projectMembers.find();
      let resourcesTypes = JSON.parse(JSON.stringify(results));
      // console.log('resourcesTypes', resourcesTypes);
       resourcesTypes = this.groupBy(resourcesTypes, 'resourcesType');
      // console.log('resourcesTypes grouped', resourcesTypes);

      for (const resourcesType of Object.keys(resourcesTypes)){
        const obj = {
          name: resourcesType,
          value: resourcesTypes[resourcesType].length
        };
        this.single.push(obj);
    }
    this.single = [...this.single];
  }


  async getEmployeeListForReportingTo(): Promise<void>{
    const Profile = this.parseService.instance.Object.extend('Profile');
    const profile = new this.parseService.instance.Query(Profile);
    profile.equalTo('isActive', true);
    profile.equalTo('isLongLeave', false);
    profile.limit(1000);
    profile.include('role');
    profile.include('department');
    profile.include('reportingTo');
    profile.ascending('firstName');
    profile.equalTo('tenantId', this.tenantId);
    const profileList = await profile.find();
    const res = JSON.parse(JSON.stringify(profileList));
    // console.log('res profile', res);
    const reportingToIds = res.filter((data) => data.role.reportingTo === true);
    reportingToIds.forEach((ress) => {
      const reportingToOwner = res.filter((data) => data.reportingTo.objectId === ress.objectId);
      const obj = {
        name: ress.username,
        value: reportingToOwner.length
      };
      this.reportingToWithCount.push(obj);
    });
    this.reportingToWithCount = [...this.reportingToWithCount];
    // console.log('reportingToWithCount', this.reportingToWithCount);
  }



  async getEmployeeListForReportingToWithBillingType(): Promise<void>{
    const Profile = this.parseService.instance.Object.extend('Profile');
    const profile = new this.parseService.instance.Query(Profile);
    profile.equalTo('isActive', true);
    profile.equalTo('isLongLeave', false);
    profile.limit(1000);
    profile.include('role');
    profile.include('department');
    profile.include('reportingTo');
    profile.ascending('firstName');
    profile.equalTo('tenantId', this.tenantId);
    const profileList = await profile.find();
    const result = JSON.parse(JSON.stringify(profileList));
    const reportingToIds = result.filter((data) => data.role.reportingTo === true);
    this.BillingTypeNames.forEach((type) => {

      reportingToIds.forEach(async (ress) => {
        const reportingToOwner = result.filter((data) => data.reportingTo.objectId === ress.objectId).map((data) => data.objectId);
        // console.log('reportingToOwnerIds', reportingToOwner);
        const User = this.parseService.instance.Object.extend('User');
        const userQuery = new this.parseService.instance.Query(User);
        userQuery.containedIn('profile', [...reportingToOwner]);
       let userResult = await userQuery.find();
       if (userResult.length > 0) {
         userResult = JSON.parse(JSON.stringify(userResult));
        //  console.log('reportingToOwnerUserIds', userResult);
         const userIds = userResult.map((data) => data.objectId);
  
         const ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
         const projectMembersQuery = new this.parseService.instance.Query(ProjectMembers);
         projectMembersQuery.containedIn('user', userIds);
         projectMembersQuery.equalTo('resourcesType', type.resourcesType);
         let projectMembersResult =  await projectMembersQuery.find();
  
         projectMembersResult = JSON.parse(JSON.stringify(projectMembersResult));
         if (projectMembersResult.length > 0) {
          const obj = {
            name: ress.username,
            value: projectMembersResult.length
          };
          // this.reportingToWithBillingType.push(obj);
          this[type.arrayNameToPush].push(obj);
         }
         this[type.arrayNameToPush] = [...this[type.arrayNameToPush]];
        //  console.log(type.arrayNameToPush, this[type.arrayNameToPush]);       
        }
      });
    });
  }

  onResize(event): void{
    this.view = [event.target.innerWidth / this.ngxChartWidth, 400];
  }

  /**
   * * groupBy function is used to group the array based on keyName 
   * @Params array: need to pass the array
   * @Params Key: need to pass the key name 
   */
     groupBy = (array, key) => {
      // Return the end result
      return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
          currentValue
        );
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
      }, {}); // empty object is the initial value for result object
    }

}
